import Immutable from 'seamless-immutable'
import * as actions from './actions'

const initialState = Immutable.from({
  isFetching: false,
  error: false,
  searchQuery: null,
  data: [],
})

const toplistings = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_TOPLISTINGS:
      return {
        ...state,
        isFetching: true,
      }
    case actions.RECEIVE_TOPLISTINGS:
      if (error) {
        return {
          ...initialState,
          error: payload,
        }
      }
      return {
        ...initialState,
        searchQuery: payload.searchQuery,
        data: payload.data,
      }
    default:
      return state
  }
}

export default toplistings
